import TableHeader from "../../components/table_header"
import { PROJECTS_HEADINGS } from "../../utils/constants"
import { IProjectDetail } from "../../utils/types"

const ProjectTable = (props:any)=>{
    const handleClick = (e: React.MouseEvent<HTMLTableRowElement>, project: IProjectDetail)=>{
      props.handleSelect(project)
    }
    return (
    
        <table className="w-full text-left p-2 mx-auto border">
          <TableHeader data={PROJECTS_HEADINGS} />
          <tbody className="w-full text-sm">
            {props.data && props.data.map((row:IProjectDetail) => {
              return (
                <tr key={row.id} className="text-sm border-b border-b-gray-200 py-8 hover:bg-gray-100 cursor-pointer px-2 items-start" onClick={(e)=>{handleClick(e,row)}}>
                  <td className="border-bottom px-1 py-2">{row.name}
                  </td>
                  <td className="border-bottom px-1 py-2">{`${row.code}`}
                  </td>
                  {/* <td className="border-bottom px-1 py-2">{row.nameOfRequestor}
                  </td> */}
                  <td className="border-bottom px-1 py-2">{`${row.donor}`}</td>
                  <td className="border-bottom px-1 py-2">{row.coordinator_detail?.fname} {row.coordinator_detail?.lname}
                  </td>
                  <td className="border-bottom px-1 py-2">{row.coordinator_detail?.department_detail?.code}
                  </td>
                  <td className="border-bottom px-1 py-2">{row.status == 0  ? 'Active': 'Closed'}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
        )
}
export default ProjectTable